export const TIME_UNITS = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
export const DEFAULT_TIME_UNITS_FORM = {
  model: { timeUnits: 1 },
  dirty: false,
  status: '',
  errors: {},
};
